import { useSearchParams } from 'react-router-dom';
import { PurchasesList } from 'components/Purchases/purchases-list';
import { useSnack } from 'shared/ui/snack';
import useConfirmDialog from 'hooks/confirm-dialog.hook';
import { PurchaseInfoDto } from '@sr/dto';
import { Heading } from 'shared/ui/list-page-heading';
import { usePurchases } from 'hooks/purchases-list.hook';
import { useTitleHook } from 'hooks/page-title.hook';
import { usePagingParams } from 'shared/hooks/paging-params';
import { deletePurchase } from 'shared/api/purchases';

const PurchasesListPage = () => {
  useTitleHook('Заявки на размещение');
  const [paging, setPaging] = usePagingParams();
  const [searchParams] = useSearchParams();
  const collection = usePurchases(paging, new URLSearchParams(searchParams).toString());

  const { showSuccess, showError } = useSnack();
  const showConfirmDialog = useConfirmDialog();

  const handleDeletePurchase = (purchase: PurchaseInfoDto) => {
    showConfirmDialog({
      content: 'Удалить заявку?',
      rejectOnCancel: false,
    }).then(() => {
      deletePurchase(purchase.id)
        .then(() => {
          showSuccess('Заявка успешно удалена');
          collection.reload && collection.reload();
        })
        .catch((e) => showError(`Ошибка удаления заявки: ${e}`));
    });
  };

  return (
    <>
      <Heading title="Заявки на размещение" />

      <PurchasesList collection={collection} paging={paging} onChangePaging={setPaging} onDelete={handleDeletePurchase} />
    </>
  );
};

export default PurchasesListPage;
